export class AnalyseParticulierInput
{
    codeTypeCredit:String;
    employeur:String;
    salaireEmprunteur:number;
    montantDemande:number;
    montantAutreRevenu:number;
    salaireConjoint:number;
    montantLoyer:number;
    echeanceMensuelleEnCours:number;
    echeanceMois:number;
    echeanceMaxEmployeurMois:number;
    totalEngagementActuel:number;
    differe:number;
    categorie:String;
    montantBonusDat:number;
    primeTrimestrielle:number;
}